import React from "react";
import { Link, useNavigate } from "react-router-dom";

import { Plus,ArrowLeft  } from 'lucide-react';
const Content = ({
  Page_title,
  button_title,
  button_title1,
  backForword,
  Page_title_showClient,
  backbutton_title,
  button_status,
  button_status1,
  backbutton_status,
  route,
  route1,
  state1,
  permissions,
  ...rest
}) => {
  const navigate = useNavigate();


  const handleHomeClick = () => {
    navigate("/");
  };

  const handleBackClick = () => {
    if (backbutton_title === "Back") {
      window.history.back();
    }
  };
  return (
    <div className="content-body">
  

     
           
                <div className="card form-card">
                  <div className="card-body">
                    <div className="form-validation" style={{ minHeight: "500px" }}>{rest.children}</div>
                  </div>
                </div>
              </div>
          
       
  );
};

export default Content;
